import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { headerClassName } from '@fluentui/react-northstar';

export const SideNav: StyleRule = ({ theme }) => {
    return {
        position: 'absolute',
        top: pxToRem(108),
        height: pxToRem(63),
        marginBottom: pxToRem(12),
        overflowY: 'auto',
        scrollbarWidth: 'none',
        maxWidth: '100%',
        [`&::-webkit-scrollbar`]: {
            width: 0,
        },
        [`&::-webkit-scrollbar-track`]: {
            background: 'transparent',
        },
        [`&::-webkit-scrollbar-thumb`]: {
            background: 'transparent',
        },

        [theme.screen.laptop]: {
            position: 'sticky',
            height: '100vh',
            width: pxToRem(200),
            left: 0,
            top: 0,
            zIndex: theme.siteVariables.zIndexes.menuItem,
            background: 'transparent',
            padding: pxArrayToRem([44, 24]),
            overflowY: 'hidden',
            marginBottom: 0,
            marginTop: '-100vh',
        },
    };
};

export const NavHead: StyleRule = ({ theme }) => {
    return {
        display: 'none',
        [theme.screen.laptop]: {
            display: 'inline-block',
            [`& .${headerClassName}`]: {
                ...theme.siteVariables.textStyles.Heading.Medium65,
                textTransform: 'uppercase',
                fontSize: pxToRem(12.35),
                lineHeight: theme.siteVariables.lineHeightDefault,
                margin: 0,
            },
        },
    };
};

export const NavBody: StyleRule = ({ theme }) => {
    return {
        display: 'flex',
        gap: pxToRem(8.5),
        flexDirection: 'row',
        listStyle: 'none',
        margin: 0,
        padding: pxArrayToRem([5, 19]),

        [theme.screen.laptop]: {
            display: 'inline-block',
            position: 'absolute',
            width: '100%',
            top: '50%',
            left: 0,
            transform: 'translateY(-50%)',
            padding: pxArrayToRem([0, 24]),
        },
    };
};

export const NavItem: StyleRule = ({ theme }) => {
    return {
        [theme.screen.max.laptop]: {
            padding: pxArrayToRem([9, 18]),
            height: pxToRem(40),
            letterSpacing: '-0.02em',
            whiteSpace: 'nowrap',
            fontSize: theme.siteVariables.fontSizes.caption03,
            [`&.active`]: {
                background: 'black',
                [`& a`]: {
                    color: theme.siteVariables.colors.primitive.white,
                },
            },
            [`&.not-active`]: {
                border: `1px solid #E8E8E8`,
            },
        },
        [theme.screen.laptop]: {
            ...theme.siteVariables.textStyles.Heading.Medium65,
            fontSize: theme.siteVariables.fontSizes.subheading04,
            lineHeight: theme.siteVariables.lineHeightDefault,
            marginBottom: pxToRem(7),
            textTransform: 'uppercase',
        },
    };
};

export const NavLink: StyleRule = ({ theme }) => {
    return {
        color: theme.siteVariables.colors.charcoal['000'],
        textDecoration: 'none',
        [`&:hover`]: {
            textDecoration: 'none',
        },
    };
};
